export default "__VITE_ASSET__DBwpSKap__"